export default "__VITE_ASSET__DK0B3DIV__"